import { Skeleton } from "@components/common/skeleton";
import { LoaderContainer } from "../chart/ChartCard/categoryChart/CategoryChart.styled";

export const CategorySkeleton = ({
  singleBlockLoader,
  minHeight
}: {
  singleBlockLoader?: boolean;
  minHeight?: string;
}) => {
  const backgroundColor = "var(--background-skeleton-0)";

  return (
    <Skeleton isLoading>
      <LoaderContainer>
        <div
          style={{
            width: "100%",
            height: "100%",
            minHeight: "357px",
            padding: "20px 24px",
            display: "flex",
            gap: "40px"
          }}
        >
          <div
            className="skeleton"
            style={{
              backgroundColor,
              flex: 1,
              alignItems: "center",
              ...(minHeight && { minHeight })
            }}
          />
          {!singleBlockLoader && (
            <div
              className="skeleton"
              style={{
                backgroundColor,
                flex: 1,
                alignItems: "center",
                ...(minHeight && { minHeight })
              }}
            />
          )}
        </div>
      </LoaderContainer>
    </Skeleton>
  );
};
